export const DIFFICULTY_MODES = {
	easy: {
		id: "easy",
		label: "Easy",
		desc: "More breathing room and slower threat ramp.",
		startingGoldMultiplier: 1.12,
		waveBudgetMultiplier: 0.88,
		bodyCapMultiplier: 0.92,
		adaptiveSensitivity: 0.82,
	},
	medium: {
		id: "medium",
		label: "Medium",
		desc: "Baseline adaptive pressure.",
		startingGoldMultiplier: 1,
		waveBudgetMultiplier: 1,
		bodyCapMultiplier: 1,
		adaptiveSensitivity: 1,
	},
	hard: {
		id: "hard",
		label: "Hard",
		desc: "Sharper scaling and less spare economy.",
		startingGoldMultiplier: 0.9,
		waveBudgetMultiplier: 1.13,
		bodyCapMultiplier: 1.08,
		adaptiveSensitivity: 1.18,
	},
};

export const DIFFICULTY_ORDER = ["easy", "medium", "hard"];

export const normalizeDifficultyMode = (value) => DIFFICULTY_MODES[value] ? value : "medium";

export const getDifficultyModeProfile = (value) => DIFFICULTY_MODES[normalizeDifficultyMode(value)];
